import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { notifierConfig, tokens } from '../../constants';
export var getNotifierStyles = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var size = props.size,
    config = props.config,
    _props$state = props.state,
    state = _props$state === void 0 ? 'default' : _props$state,
    hasDot = props.hasDot;
  var _size = (_b = (_a = config === null || config === void 0 ? void 0 : config.size) === null || _a === void 0 ? void 0 : _a[size]) === null || _b === void 0 ? void 0 : _b.notifierNumberSize;
  var backgroundColor = (_d = (_c = config === null || config === void 0 ? void 0 : config.controlState) === null || _c === void 0 ? void 0 : _c[state]) === null || _d === void 0 ? void 0 : _d.backgroundColor;
  var borderColor = (_f = (_e = config === null || config === void 0 ? void 0 : config.controlState) === null || _e === void 0 ? void 0 : _e[state]) === null || _f === void 0 ? void 0 : _f.dotBorderColor;
  if (hasDot) {
    _size = (_h = (_g = config === null || config === void 0 ? void 0 : config.size) === null || _g === void 0 ? void 0 : _g[size]) === null || _h === void 0 ? void 0 : _h.notifierDotSize;
  }
  return StyleSheet.create({
    container: {
      height: _size,
      width: _size,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_100,
      borderWidth: hasDot ? 1 : 0,
      borderColor
    }
  });
};
export var getNotifierProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(notifierConfig === null || notifierConfig === void 0 ? void 0 : notifierConfig[theme], ((_a = context === null || context === void 0 ? void 0 : context.notifier) === null || _a === void 0 ? void 0 : _a[theme]) || {});
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};